import Resource from '@/plugins/sdk/Resource'
import { STRING, BOOLEAN, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'main'

  static get fields () {
    return {
      id: new UUID(),
      key: new STRING(),
      hash: new STRING(),
      shipper: new BOOLEAN(),
      biller: new BOOLEAN(),
      channel: new STRING()
    }
  }
}
